<div class="wrapper">
  @if (loading) {
    <div class="overlay">
      <div class="spinner-wrapper">
        <tds-spinner size="lg" variant="standard"></tds-spinner>
      </div>
    </div>
  }

  <div class="loaded-content" [class.blurred]="loading">
    <ng-content></ng-content>
  </div>
</div>

<div id="content-mobile">
  <div style="text-align: center; padding: var(--tds-spacing-layout-8);">
    <h2>{{getLanguageItem( 'navcompare' )}}</h2>
  </div>

  <div class="tds-row" style="display: flex; justify-content: center;">
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-10 tds-col-xs-10">
      <tds-dropdown name="dropdown" label="{{getLanguageItem( 'selectmeeting' )}}" label-position="inside">
        @for (meeting of meetingList; track meeting) {
          <tds-dropdown-option (click)="getSessions(meeting.id, true)" value="{{meeting.id}}">
            {{meeting.name}}
          </tds-dropdown-option>
        }
      </tds-dropdown>
    </div>
  </div>

  <div class="mobile-compare-grid" style="padding-top: 16px;">

    <div class="mobile-compare-scroll">
      <div class="mobile-compare-table">
        <div class="label-cell sticky-col">
          <h2 class="tds-headline-05">{{ getLanguageItem('selectdate') }}</h2>
        </div>
        <div class="data-cell">
          <tds-dropdown name="dropdown" label="{{getLanguageItem('selectdate')}}" label-position="inside">
            @for (date of dateListLeft; track date) {
              <tds-dropdown-option (click)="getParticipants(date.id, true)" value="{{date.id}}">
                {{ date.sessionDate | date:'yyyy-MM-dd' }}
              </tds-dropdown-option>
            }
          </tds-dropdown>
        </div>
        <div class="data-cell">
          <tds-dropdown name="dropdown" label="{{getLanguageItem('selectdate')}}" label-position="inside">
            @for (date of dateListRight; track date) {
              <tds-dropdown-option (click)="getParticipants(date.id)" value="{{date.id}}">
                {{ date.sessionDate | date:'yyyy-MM-dd' }}
              </tds-dropdown-option>
            }
          </tds-dropdown>
        </div>
        <div class="data-cell">
          <tds-dropdown name="dropdown" label="{{getLanguageItem('selectdate')}}" label-position="inside">
            @for (date of dateListThird; track date) {
              <tds-dropdown-option (click)="getParticipantsExtra(date.id, 3)" value="{{date.id}}">
                {{ date.sessionDate | date:'yyyy-MM-dd' }}
              </tds-dropdown-option>
            }
          </tds-dropdown>
        </div>
        <div class="data-cell">
          <tds-dropdown name="dropdown" label="{{getLanguageItem('selectdate')}}" label-position="inside">
            @for (date of dateListFourth; track date) {
              <tds-dropdown-option (click)="getParticipantsExtra(date.id, 4)" value="{{date.id}}">
                {{ date.sessionDate | date:'yyyy-MM-dd' }}
              </tds-dropdown-option>
            }
          </tds-dropdown>
        </div>
        <div class="label-cell sticky-col">
          <h2 class="tds-headline-05">{{ getLanguageItem('numberofparticipants') }}</h2>
        </div>
        <div class="data-cell data-center"><p class="tds-body-01">{{ getNumberOfParticipants(participantsLeft) }}</p></div>
        <div class="data-cell data-center"><p class="tds-body-01">{{ getNumberOfParticipants(participantsRight) }}</p></div>
        <div class="data-cell data-center"><p class="tds-body-01">{{ getNumberOfParticipants(participantsThird) }}</p></div>
        <div class="data-cell data-center"><p class="tds-body-01">{{ getNumberOfParticipants(participantsFourth) }}</p></div>

        @for (section of sections; track section) {
          <div class="label-cell sticky-col">
            <h2 class="tds-headline-05">{{ getLanguageItem(section) }}</h2>
          </div>
          <div class="data-cell">
            <div class="mobile-faces">
              @for (p of participantsLeft; track p) {
                @if (p.getSectionValue(section) === 'excellent') {
                  <img [src]="faces[0].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'good') {
                  <img [src]="faces[1].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'insufficient') {
                  <img [src]="faces[2].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'poor') {
                  <img [src]="faces[3].img" class="mobile-face" alt="">
                }
              }
            </div>
          </div>
          <div class="data-cell">
            <div class="mobile-faces">
              @for (p of participantsRight; track p) {
                @if (p.getSectionValue(section) === 'excellent') {
                  <img [src]="faces[0].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'good') {
                  <img [src]="faces[1].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'insufficient') {
                  <img [src]="faces[2].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'poor') {
                  <img [src]="faces[3].img" class="mobile-face" alt="">
                }
              }
            </div>
          </div>
          <div class="data-cell">
            <div class="mobile-faces">
              @for (p of participantsThird; track p) {
                @if (p.getSectionValue(section) === 'excellent') {
                  <img [src]="faces[0].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'good') {
                  <img [src]="faces[1].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'insufficient') {
                  <img [src]="faces[2].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'poor') {
                  <img [src]="faces[3].img" class="mobile-face" alt="">
                }
              }
            </div>
          </div>
          <div class="data-cell">
            <div class="mobile-faces">
              @for (p of participantsFourth; track p) {
                @if (p.getSectionValue(section) === 'excellent') {
                  <img [src]="faces[0].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'good') {
                  <img [src]="faces[1].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'insufficient') {
                  <img [src]="faces[2].img" class="mobile-face" alt="">
                }
                @if (p.getSectionValue(section) === 'poor') {
                  <img [src]="faces[3].img" class="mobile-face" alt="">
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div style="padding-top: 20px;"></div>
</div>

<div id="content-desktop" style="margin-top: 10px;">
  <div class="tds-row" style="padding: 5px;">
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12" style="display: flex; justify-content: center;">
      <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
        <tds-dropdown name="dropdown" label="{{getLanguageItem( 'selectmeeting' )}}" label-position="inside">
          @for (meeting of meetingList; track meeting) {
            <tds-dropdown-option (click)="getSessions(meeting.id, true)" value="{{meeting.id}}">
              {{meeting.name}}
            </tds-dropdown-option>
          }
        </tds-dropdown>
      </div>
      <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
        <tds-dropdown name="dropdown" label="{{getLanguageItem( 'selectdate' )}}" label-position="inside">
          @for (date of dateListLeft; track date) {
            <tds-dropdown-option (click)="getParticipants(date.id, true)" value="{{date.id}}">
              {{date.sessionDate | date:'yyyy-MM-dd'}}
            </tds-dropdown-option>
          }
        </tds-dropdown>
      </div>
    </div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12" style="display: flex; justify-content: center;">
      <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
        <p>{{getLanguageItem( 'meeting' )}}:  {{getMeetingName()}}</p>
      </div>
      <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
        <tds-dropdown name="dropdown" label="{{getLanguageItem( 'selectdate' )}}" label-position="inside">
          @for (date of dateListRight; track date) {
            <tds-dropdown-option (click)="getParticipants(date.id)" value="{{date.id}}">
              {{date.sessionDate | date:'yyyy-MM-dd'}}
            </tds-dropdown-option>
          }
        </tds-dropdown>
      </div>
    </div>
  </div>

  <div class="tds-row" style="padding: 10px;">
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12" style="text-align: center;">
      <p>{{getLanguageItem( 'numberofparticipants' )}}: {{getNumberOfParticipants(participantsLeft)}}</p>
    </div>
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12" style="text-align: center;">
      <p>{{getLanguageItem( 'numberofparticipants' )}}: {{getNumberOfParticipants(participantsRight)}}</p>
    </div>
  </div>


  <div class="tds-row" style="display: flex; justify-content: center; text-align: center;">
    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
      <svg width="600" height="650" xmlns="http://www.w3.org/2000/svg">
        <g transform="scale(0.4)">
          <circle (mouseover)="setTitle($event)" (mouseout)="clearTitle()" style="fill:rgb(21, 24, 67);"
            cx="716.085" cy="810.12" r="695.5" />
          <title>{{getTitle()}}</title>

          <path
            d="M 20.627 804.382 L 712.563 804.382 L 712.563 815.858 L 20.627 815.858 C 20.59 812.77 20.57 812.487 20.58 809.847 C 20.589 807.244 20.58 807.15 20.627 804.382 Z"
            style="fill: rgb(175, 185, 213);" />
          <path
            d="M 719.694 815.858 L 1411.63 815.858 L 1411.63 804.382 L 719.694 804.382 C 719.657 807.47 719.637 807.753 719.647 810.393 C 719.656 812.996 719.647 813.09 719.694 815.858 Z"
            style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 2131.274414, 1620.23999)" />
          <path
            d="M 715.512 0.084 C 718.194 0.046 720.069 -0.2 722.861 2.296 C 725.345 4.959 725.318 6.941 725.607 14.37 L 747.477 1564.276 L 715.372 1564.276 L 715.512 0.084 Z"
            style="fill: rgb(199, 206, 229);" />
          <path
            d="M 688.858 1563.166 C 691.54 1563.204 693.415 1563.45 696.207 1560.954 C 698.691 1558.291 698.664 1556.309 698.953 1548.88 L 721.945 -1.026 L 689.018 -1.026 L 688.858 1563.166 Z"
            style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 1405.588989, 1563.112183)" />
          <rect x="595.819" y="1559.695" width="241.266" height="35.402" style="fill: rgb(175, 185, 213);"
            rx="9.48" ry="9.48" />
          <rect x="690.691" y="1559.695" width="146.394" height="35.105" style="fill: rgb(199, 206, 229);"
            rx="9.48" ry="9.48" />

          <g transform="matrix(1, 0, 0, 1.026298, 1265.407593, -70.336105)">
            <path
              d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
              style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
            <path
              d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
              style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
            <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
              style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
              transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
            <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);"
              x1="160.745" y1="353.476" x2="89.88" y2="353.476" />
            <line
              style="stroke-width: 16px; stroke-linecap: round; fill: rgb(150, 156, 182); stroke: rgb(155, 165, 192);"
              x1="82.52" y1="353.476" x2="10.503" y2="353.476" />
          </g>

          <path
            d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
            style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
          <path
            d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
            style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
          <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
            style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
            transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
          <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);" x1="160.745"
            y1="353.476" x2="72.895" y2="353.476" />
          <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(155, 165, 192);" x1="80.749"
            y1="353.792" x2="13.129" y2="353.792" />

          <rect x="77.523" y="62.42" width="1301.521" height="24.403" style="fill: rgb(115, 116, 139);"
            rx="12.201" ry="12.201"
            transform="matrix(0.998944, -0.04595, 0.04595, 0.998944, -14.161609, 16.940481)" />

          <circle style="fill: rgb(150, 156, 182);" cx="716.793" cy="57.932" r="34.236" />
          <circle style="fill: rgb(175, 185, 213);" cx="716.793" cy="57.932" r="14.341" />
          <circle style="fill: rgb(175, 185, 213);" cx="84.487" cy="86.683" r="7.085" />
          <circle style="fill: rgb(175, 185, 213);" cx="1349.311" cy="27.363" r="7.085" />


          @if (getLabelLength(getLanguageItem( 'manageability' ))<18) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660" y="410">{{getLanguageItem(
              'manageability' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageability' ))>17) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="390">{{getFirstHalfOfLabel(getLanguageItem( 'manageability' ))}}</text>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="430">{{getRestOfLabel(getLanguageItem( 'manageability' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))<25) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="510">{{getLanguageItem(
              'manageabilityrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))>24) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="490">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow1' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="530">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))<30) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="590">{{getLanguageItem(
              'manageabilityrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))>29) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="570">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow2' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="610">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))<33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="670">{{getLanguageItem(
              'manageabilityrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))>32) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="650">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow3' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="690">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))<34) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="750">{{getLanguageItem(
              'manageabilityrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))>33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="730">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow4' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="770">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow4' ))}}</text>
            </g>
          }


          @if (getLabelLength(getLanguageItem( 'meaningfulness' ))<18) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660" y="900">{{getLanguageItem(
              'meaningfulness' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulness' ))>17) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="880">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="920">{{getRestOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))<34) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1010">{{getLanguageItem(
              'meaningfulnessrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))>33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="990">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1030">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))<33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1090">{{getLanguageItem(
              'meaningfulnessrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))>32) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1110">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))<30) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1170">{{getLanguageItem(
              'meaningfulnessrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))>29) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1190">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))<25) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1250">{{getLanguageItem(
              'meaningfulnessrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))>24) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1270">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
            </g>
          }


          @if (getLabelLength(getLanguageItem( 'recovery' ))<18) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770" y="900">{{getLanguageItem(
              'recovery' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recovery' ))>17) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="880">{{getFirstHalfOfLabel(getLanguageItem( 'recovery' ))}}</text>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="920">{{getRestOfLabel(getLanguageItem( 'recovery' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))<34) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1010">{{getLanguageItem(
              'recoveryrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))>33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="990">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1030">{{getRestOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))<33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1090">{{getLanguageItem(
              'recoveryrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))>32) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1100">{{getRestOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))<30) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1170">{{getLanguageItem(
              'recoveryrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))>29) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1190">{{getRestOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))<25) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1250">{{getLanguageItem(
              'recoveryrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))>24) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1270">{{getRestOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
            </g>
          }


          @if (getLabelLength(getLanguageItem( 'comprehensibility' ))<18) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770" y="410">{{getLanguageItem(
              'comprehensibility' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibility' ))>17) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="390">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="430">{{getRestOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))<25) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="510">{{getLanguageItem(
              'comprehensibilityrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))>24) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="490">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="530">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))<30) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="590">{{getLanguageItem(
              'comprehensibilityrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))>29) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="570">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="610">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))<33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="670">{{getLanguageItem(
              'comprehensibilityrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))>32) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="650">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="690">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))<34) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="750">{{getLanguageItem(
              'comprehensibilityrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))>33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="730">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="770">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
            </g>
          }

          @for (p of participantsLeft; track p) {
            <use
              attr.transform="translate({{p.handlingX}}, {{p.handlingY}})"
              attr.xlink:href="{{getFaceColor(p.handlingValue)}}" />
          }
          @for (p of participantsLeft; track p) {
            <use
              attr.transform="translate({{p.meaningfulnessX}}, {{p.meaningfulnessY}})"
              attr.xlink:href="{{getFaceColor(p.meaningfulnessValue)}}" />
          }
          @for (p of participantsLeft; track p) {
            <use
              attr.transform="translate({{p.understandableX}}, {{p.understandableY}})"
              attr.xlink:href="{{getFaceColor(p.understandableValue)}}" />
          }
          @for (p of participantsLeft; track p) {
            <use attr.transform="translate({{p.recoverX}}, {{p.recoverY}})"
              attr.xlink:href="{{getFaceColor(p.recoverValue)}}" />
          }
        </g>
        <g id="excellent" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#151843;stroke:#fff;stroke-width:2px;" />
          <path
            d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
            style="fill:#151843;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

        <g id="good" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#9cb2a2;stroke:#fff;stroke-width:2px;" />
          <path
            d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
            style="fill:#151843;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

        <g id="unsatisfying" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#dbbf8d;stroke:#fff;stroke-width:2px;" />
          <path d="M19.196,48.757l29.076,-9.884" style="fill:none;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

        <g id="bad" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#de0621;stroke:#fff;stroke-width:2px;" />
          <path
            d="M45.219,47.959c0,-3.7 -5.903,-6.704 -13.175,-6.704c-7.272,-0 -13.176,3.004 -13.176,6.704c-0,-3.7 5.904,-6.704 13.176,-6.704c7.272,-0 13.175,3.004 13.175,6.704Z"
            style="fill:#151843;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

      </svg>
    </div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
      <svg width="600" height="650" xmlns="http://www.w3.org/2000/svg">
        <g transform="scale(0.4)">
          <circle (mouseover)="setTitle($event)" (mouseout)="clearTitle()" style="fill:rgb(21, 24, 67);"
            cx="716.085" cy="810.12" r="695.5" />
          <title>{{getTitle()}}</title>

          <path
            d="M 20.627 804.382 L 712.563 804.382 L 712.563 815.858 L 20.627 815.858 C 20.59 812.77 20.57 812.487 20.58 809.847 C 20.589 807.244 20.58 807.15 20.627 804.382 Z"
            style="fill: rgb(175, 185, 213);" />
          <path
            d="M 719.694 815.858 L 1411.63 815.858 L 1411.63 804.382 L 719.694 804.382 C 719.657 807.47 719.637 807.753 719.647 810.393 C 719.656 812.996 719.647 813.09 719.694 815.858 Z"
            style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 2131.274414, 1620.23999)" />
          <path
            d="M 715.512 0.084 C 718.194 0.046 720.069 -0.2 722.861 2.296 C 725.345 4.959 725.318 6.941 725.607 14.37 L 747.477 1564.276 L 715.372 1564.276 L 715.512 0.084 Z"
            style="fill: rgb(199, 206, 229);" />
          <path
            d="M 688.858 1563.166 C 691.54 1563.204 693.415 1563.45 696.207 1560.954 C 698.691 1558.291 698.664 1556.309 698.953 1548.88 L 721.945 -1.026 L 689.018 -1.026 L 688.858 1563.166 Z"
            style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 1405.588989, 1563.112183)" />
          <rect x="595.819" y="1559.695" width="241.266" height="35.402" style="fill: rgb(175, 185, 213);"
            rx="9.48" ry="9.48" />
          <rect x="690.691" y="1559.695" width="146.394" height="35.105" style="fill: rgb(199, 206, 229);"
            rx="9.48" ry="9.48" />

          <g transform="matrix(1, 0, 0, 1.026298, 1265.407593, -70.336105)">
            <path
              d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
              style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
            <path
              d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
              style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
            <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
              style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
              transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
            <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);"
              x1="160.745" y1="353.476" x2="89.88" y2="353.476" />
            <line
              style="stroke-width: 16px; stroke-linecap: round; fill: rgb(150, 156, 182); stroke: rgb(155, 165, 192);"
              x1="82.52" y1="353.476" x2="10.503" y2="353.476" />
          </g>

          <path
            d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
            style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
          <path
            d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
            style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
          <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
            style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
            transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
          <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);" x1="160.745"
            y1="353.476" x2="72.895" y2="353.476" />
          <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(155, 165, 192);" x1="80.749"
            y1="353.792" x2="13.129" y2="353.792" />

          <rect x="77.523" y="62.42" width="1301.521" height="24.403" style="fill: rgb(115, 116, 139);"
            rx="12.201" ry="12.201"
            transform="matrix(0.998944, -0.04595, 0.04595, 0.998944, -14.161609, 16.940481)" />

          <circle style="fill: rgb(150, 156, 182);" cx="716.793" cy="57.932" r="34.236" />
          <circle style="fill: rgb(175, 185, 213);" cx="716.793" cy="57.932" r="14.341" />
          <circle style="fill: rgb(175, 185, 213);" cx="84.487" cy="86.683" r="7.085" />
          <circle style="fill: rgb(175, 185, 213);" cx="1349.311" cy="27.363" r="7.085" />


          @if (getLabelLength(getLanguageItem( 'manageability' ))<18) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660" y="410">{{getLanguageItem(
              'manageability' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageability' ))>17) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="390">{{getFirstHalfOfLabel(getLanguageItem( 'manageability' ))}}</text>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="430">{{getRestOfLabel(getLanguageItem( 'manageability' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))<25) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="510">{{getLanguageItem(
              'manageabilityrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))>24) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="490">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow1' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="530">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))<30) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="590">{{getLanguageItem(
              'manageabilityrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))>29) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="570">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow2' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="610">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))<33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="670">{{getLanguageItem(
              'manageabilityrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))>32) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="650">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow3' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="690">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))<34) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="750">{{getLanguageItem(
              'manageabilityrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))>33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="730">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow4' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660" y="770">{{getRestOfLabel(getLanguageItem(
              'manageabilityrow4' ))}}</text>
            </g>
          }


          @if (getLabelLength(getLanguageItem( 'meaningfulness' ))<18) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660" y="900">{{getLanguageItem(
              'meaningfulness' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulness' ))>17) {
            <g>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="880">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
              <text style="text-anchor:end;" class="svgheaderfont" x="660"
              y="920">{{getRestOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))<34) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1010">{{getLanguageItem(
              'meaningfulnessrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))>33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="990">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1030">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))<33) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1090">{{getLanguageItem(
              'meaningfulnessrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))>32) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1110">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))<30) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1170">{{getLanguageItem(
              'meaningfulnessrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))>29) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1190">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))<25) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660" y="1250">{{getLanguageItem(
              'meaningfulnessrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))>24) {
            <g>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
              <text style="text-anchor:end;" class="svgfont" x="660"
              y="1270">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
            </g>
          }


          @if (getLabelLength(getLanguageItem( 'recovery' ))<18) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770" y="900">{{getLanguageItem(
              'recovery' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recovery' ))>17) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="880">{{getFirstHalfOfLabel(getLanguageItem( 'recovery' ))}}</text>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="920">{{getRestOfLabel(getLanguageItem( 'recovery' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))<34) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1010">{{getLanguageItem(
              'recoveryrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))>33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="990">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1030">{{getRestOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))<33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1090">{{getLanguageItem(
              'recoveryrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))>32) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1100">{{getRestOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))<30) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1170">{{getLanguageItem(
              'recoveryrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))>29) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1190">{{getRestOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))<25) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="1250">{{getLanguageItem(
              'recoveryrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))>24) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="1270">{{getRestOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
            </g>
          }


          @if (getLabelLength(getLanguageItem( 'comprehensibility' ))<18) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770" y="410">{{getLanguageItem(
              'comprehensibility' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibility' ))>17) {
            <g>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="390">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
              <text style="text-anchor:start;" class="svgheaderfont" x="770"
              y="430">{{getRestOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))<25) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="510">{{getLanguageItem(
              'comprehensibilityrow1' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))>24) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="490">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="530">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))<30) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="590">{{getLanguageItem(
              'comprehensibilityrow2' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))>29) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="570">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="610">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))<33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="670">{{getLanguageItem(
              'comprehensibilityrow3' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))>32) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="650">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="690">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))<34) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770" y="750">{{getLanguageItem(
              'comprehensibilityrow4' )}}</text>
            </g>
          }
          @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))>33) {
            <g>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="730">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
              <text style="text-anchor:start;" class="svgfont" x="770"
              y="770">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
            </g>
          }

          @for (p of participantsRight; track p) {
            <use
              attr.transform="translate({{p.handlingX}}, {{p.handlingY}})"
              attr.xlink:href="{{getFaceColor(p.handlingValue)}}" />
          }
          @for (p of participantsRight; track p) {
            <use
              attr.transform="translate({{p.meaningfulnessX}}, {{p.meaningfulnessY}})"
              attr.xlink:href="{{getFaceColor(p.meaningfulnessValue)}}" />
          }
          @for (p of participantsRight; track p) {
            <use
              attr.transform="translate({{p.understandableX}}, {{p.understandableY}})"
              attr.xlink:href="{{getFaceColor(p.understandableValue)}}" />
          }
          @for (p of participantsRight; track p) {
            <use attr.transform="translate({{p.recoverX}}, {{p.recoverY}})"
              attr.xlink:href="{{getFaceColor(p.recoverValue)}}" />
          }
        </g>
        <g id="excellent" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#151843;stroke:#fff;stroke-width:2px;" />
          <path
            d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
            style="fill:#151843;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

        <g id="good" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#9cb2a2;stroke:#fff;stroke-width:2px;" />
          <path
            d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
            style="fill:#151843;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

        <g id="unsatisfying" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#dbbf8d;stroke:#fff;stroke-width:2px;" />
          <path d="M19.196,48.757l29.076,-9.884" style="fill:none;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

        <g id="bad" transform="scale(1.5625) translate(-100, -100)">
          <circle cx="32" cy="32" r="32" style="fill:#de0621;stroke:#fff;stroke-width:2px;" />
          <path
            d="M45.219,47.959c0,-3.7 -5.903,-6.704 -13.175,-6.704c-7.272,-0 -13.176,3.004 -13.176,6.704c-0,-3.7 5.904,-6.704 13.176,-6.704c7.272,-0 13.175,3.004 13.175,6.704Z"
            style="fill:#151843;stroke:#fff;stroke-width:4px;" />
          <circle cx="20" cy="23" r="6" style="fill:#fff;" />
          <circle cx="44" cy="23" r="6" style="fill:#fff;" />
        </g>

      </svg>
    </div>
  </div>

  <div style="display:flex; align-items:center; justify-content:center; gap:5px; padding:5px;">

    <tds-tooltip text="{{getLanguageItem( 'tooltipbutton1' )}}" placement="top" selector="#my-selector-button1" offset-distance="8"
      offset-skidding="0"
      mouse-over-tooltip="true"
      trigger="hover">
    </tds-tooltip>
    <tds-button
      id="my-selector-button1"
      size="md"
      variant="secondary"
      [disabled]="compareChartCount === 2"
      (click)="decrementChartCount()"
      text="−">
    </tds-button>
    <div style="font-size: 22px; font-weight: 600; min-width:40px; text-align:center;">
      {{  compareChartCount }}
    </div>
    <tds-tooltip text="{{getLanguageItem( 'modaltext1' )}}" placement="top" selector="#my-selector-button3" offset-distance="8"
      offset-skidding="0"
      mouse-over-tooltip="true"
      trigger="hover">
    </tds-tooltip>
    <tds-button
      id="my-selector-button3"
      size="md"
      variant="secondary"
      [disabled]="compareChartCount === 4"
      (click)="incrementChartCount()"
      text="+">
    </tds-button>

  </div>

  @if (compareChartCount >= 3) {
    <div>
      <div class="tds-row" style="display: flex; justify-content: center; text-align: center;">
        <!-- Chart 3 (LEFT) -->
        @if (compareChartCount >= 3) {
          <div
            class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12"
            style="display:flex; justify-content:center;"
            >
            <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
              <p>{{getLanguageItem('meeting')}}: {{getMeetingName()}}</p>
            </div>
            <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
              <tds-dropdown name="dropdown" label="{{getLanguageItem('selectdate')}}" label-position="inside">
                @for (date of dateListThird; track date) {
                  <tds-dropdown-option
                    (click)="getParticipantsExtra(date.id, 3)"
                    value="{{date.id}}">
                    {{date.sessionDate | date:'yyyy-MM-dd'}}
                  </tds-dropdown-option>
                }
              </tds-dropdown>
            </div>
          </div>
        }
        <!-- Chart 4 (RIGHT) -->
        @if (compareChartCount >= 4) {
          <div
            class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12"
            style="display:flex; justify-content:center;"
            >
            <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
              <p>{{getLanguageItem('meeting')}}: {{getMeetingName()}}</p>
            </div>
            <div class="tds-col-xxlg-4 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
              <tds-dropdown name="dropdown" label="{{getLanguageItem('selectdate')}}" label-position="inside">
                @for (date of dateListFourth; track date) {
                  <tds-dropdown-option
                    (click)="getParticipantsExtra(date.id, 4)"
                    value="{{date.id}}">
                    {{date.sessionDate | date:'yyyy-MM-dd'}}
                  </tds-dropdown-option>
                }
              </tds-dropdown>
            </div>
          </div>
        }
      </div>
      <div class="tds-row" style="display: flex; justify-content: center; text-align: center;">
        @if (compareChartCount >= 3) {
          <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12"
            style="text-align:center;"
            >
            <p>{{getLanguageItem('numberofparticipants')}}: {{getNumberOfParticipants(participantsThird)}}</p>
          </div>
        }
        @if (compareChartCount >= 4) {
          <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12"
            style="text-align:center;"
            >
            <p>{{getLanguageItem('numberofparticipants')}}: {{getNumberOfParticipants(participantsFourth)}}</p>
          </div>
        }
      </div>
      <div class="tds-row" style="display: flex; justify-content: center; text-align: center;">
        @if (compareChartCount >= 3) {
          <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
            <svg width="600" height="650" xmlns="http://www.w3.org/2000/svg">
              <g transform="scale(0.4)">
                <circle (mouseover)="setTitle($event)" (mouseout)="clearTitle()" style="fill:rgb(21, 24, 67);"
                  cx="716.085" cy="810.12" r="695.5" />
                <title>{{getTitle()}}</title>
                <path
                  d="M 20.627 804.382 L 712.563 804.382 L 712.563 815.858 L 20.627 815.858 C 20.59 812.77 20.57 812.487 20.58 809.847 C 20.589 807.244 20.58 807.15 20.627 804.382 Z"
                  style="fill: rgb(175, 185, 213);" />
                <path
                  d="M 719.694 815.858 L 1411.63 815.858 L 1411.63 804.382 L 719.694 804.382 C 719.657 807.47 719.637 807.753 719.647 810.393 C 719.656 812.996 719.647 813.09 719.694 815.858 Z"
                  style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 2131.274414, 1620.23999)" />
                <path
                  d="M 715.512 0.084 C 718.194 0.046 720.069 -0.2 722.861 2.296 C 725.345 4.959 725.318 6.941 725.607 14.37 L 747.477 1564.276 L 715.372 1564.276 L 715.512 0.084 Z"
                  style="fill: rgb(199, 206, 229);" />
                <path
                  d="M 688.858 1563.166 C 691.54 1563.204 693.415 1563.45 696.207 1560.954 C 698.691 1558.291 698.664 1556.309 698.953 1548.88 L 721.945 -1.026 L 689.018 -1.026 L 688.858 1563.166 Z"
                  style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 1405.588989, 1563.112183)" />
                <rect x="595.819" y="1559.695" width="241.266" height="35.402" style="fill: rgb(175, 185, 213);"
                  rx="9.48" ry="9.48" />
                <rect x="690.691" y="1559.695" width="146.394" height="35.105" style="fill: rgb(199, 206, 229);"
                  rx="9.48" ry="9.48" />
                <g transform="matrix(1, 0, 0, 1.026298, 1265.407593, -70.336105)">
                  <path
                    d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
                    style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
                  <path
                    d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
                    style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
                  <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
                    style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
                    transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
                  <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);"
                    x1="160.745" y1="353.476" x2="89.88" y2="353.476" />
                  <line
                    style="stroke-width: 16px; stroke-linecap: round; fill: rgb(150, 156, 182); stroke: rgb(155, 165, 192);"
                    x1="82.52" y1="353.476" x2="10.503" y2="353.476" />
                </g>
                <path
                  d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
                  style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
                <path
                  d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
                  style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
                <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
                  style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
                  transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
                <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);" x1="160.745"
                  y1="353.476" x2="72.895" y2="353.476" />
                <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(155, 165, 192);" x1="80.749"
                  y1="353.792" x2="13.129" y2="353.792" />
                <rect x="77.523" y="62.42" width="1301.521" height="24.403" style="fill: rgb(115, 116, 139);"
                  rx="12.201" ry="12.201"
                  transform="matrix(0.998944, -0.04595, 0.04595, 0.998944, -14.161609, 16.940481)" />
                <circle style="fill: rgb(150, 156, 182);" cx="716.793" cy="57.932" r="34.236" />
                <circle style="fill: rgb(175, 185, 213);" cx="716.793" cy="57.932" r="14.341" />
                <circle style="fill: rgb(175, 185, 213);" cx="84.487" cy="86.683" r="7.085" />
                <circle style="fill: rgb(175, 185, 213);" cx="1349.311" cy="27.363" r="7.085" />
                @if (getLabelLength(getLanguageItem( 'manageability' ))<18) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660" y="410">{{getLanguageItem(
                    'manageability' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageability' ))>17) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="390">{{getFirstHalfOfLabel(getLanguageItem( 'manageability' ))}}</text>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="430">{{getRestOfLabel(getLanguageItem( 'manageability' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))<25) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="510">{{getLanguageItem(
                    'manageabilityrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))>24) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="490">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow1' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="530">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))<30) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="590">{{getLanguageItem(
                    'manageabilityrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))>29) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="570">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow2' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="610">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))<33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="670">{{getLanguageItem(
                    'manageabilityrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))>32) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="650">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow3' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="690">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))<34) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="750">{{getLanguageItem(
                    'manageabilityrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))>33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="730">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow4' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="770">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow4' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulness' ))<18) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660" y="900">{{getLanguageItem(
                    'meaningfulness' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulness' ))>17) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="880">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="920">{{getRestOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))<34) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1010">{{getLanguageItem(
                    'meaningfulnessrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))>33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="990">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1030">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))<33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1090">{{getLanguageItem(
                    'meaningfulnessrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))>32) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1110">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))<30) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1170">{{getLanguageItem(
                    'meaningfulnessrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))>29) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1190">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))<25) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1250">{{getLanguageItem(
                    'meaningfulnessrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))>24) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1270">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recovery' ))<18) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770" y="900">{{getLanguageItem(
                    'recovery' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recovery' ))>17) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="880">{{getFirstHalfOfLabel(getLanguageItem( 'recovery' ))}}</text>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="920">{{getRestOfLabel(getLanguageItem( 'recovery' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))<34) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1010">{{getLanguageItem(
                    'recoveryrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))>33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="990">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1030">{{getRestOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))<33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1090">{{getLanguageItem(
                    'recoveryrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))>32) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1100">{{getRestOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))<30) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1170">{{getLanguageItem(
                    'recoveryrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))>29) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1190">{{getRestOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))<25) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1250">{{getLanguageItem(
                    'recoveryrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))>24) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1270">{{getRestOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibility' ))<18) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770" y="410">{{getLanguageItem(
                    'comprehensibility' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibility' ))>17) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="390">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="430">{{getRestOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))<25) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="510">{{getLanguageItem(
                    'comprehensibilityrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))>24) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="490">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="530">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))<30) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="590">{{getLanguageItem(
                    'comprehensibilityrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))>29) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="570">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="610">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))<33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="670">{{getLanguageItem(
                    'comprehensibilityrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))>32) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="650">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="690">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))<34) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="750">{{getLanguageItem(
                    'comprehensibilityrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))>33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="730">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="770">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
                  </g>
                }
                @for (p of participantsThird; track p) {
                  <use
                    attr.transform="translate({{p.handlingX}}, {{p.handlingY}})"
                    attr.xlink:href="{{getFaceColor(p.handlingValue)}}" />
                }
                @for (p of participantsThird; track p) {
                  <use
                    attr.transform="translate({{p.meaningfulnessX}}, {{p.meaningfulnessY}})"
                    attr.xlink:href="{{getFaceColor(p.meaningfulnessValue)}}" />
                }
                @for (p of participantsThird; track p) {
                  <use
                    attr.transform="translate({{p.understandableX}}, {{p.understandableY}})"
                    attr.xlink:href="{{getFaceColor(p.understandableValue)}}" />
                }
                @for (p of participantsThird; track p) {
                  <use
                    attr.transform="translate({{p.recoverX}}, {{p.recoverY}})"
                    attr.xlink:href="{{getFaceColor(p.recoverValue)}}" />
                }
              </g>
              <g id="excellent" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#151843;stroke:#fff;stroke-width:2px;" />
                <path
                  d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
                  style="fill:#151843;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
              <g id="good" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#9cb2a2;stroke:#fff;stroke-width:2px;" />
                <path
                  d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
                  style="fill:#151843;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
              <g id="unsatisfying" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#dbbf8d;stroke:#fff;stroke-width:2px;" />
                <path d="M19.196,48.757l29.076,-9.884" style="fill:none;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
              <g id="bad" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#de0621;stroke:#fff;stroke-width:2px;" />
                <path
                  d="M45.219,47.959c0,-3.7 -5.903,-6.704 -13.175,-6.704c-7.272,-0 -13.176,3.004 -13.176,6.704c-0,-3.7 5.904,-6.704 13.176,-6.704c7.272,-0 13.175,3.004 13.175,6.704Z"
                  style="fill:#151843;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
            </svg>
          </div>
        }
        @if (compareChartCount >= 4) {
          <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-6 tds-col-sm-12 tds-col-xs-12">
            <svg width="600" height="650" xmlns="http://www.w3.org/2000/svg">
              <g transform="scale(0.4)">
                <circle (mouseover)="setTitle($event)" (mouseout)="clearTitle()" style="fill:rgb(21, 24, 67);"
                  cx="716.085" cy="810.12" r="695.5" />
                <title>{{getTitle()}}</title>
                <path
                  d="M 20.627 804.382 L 712.563 804.382 L 712.563 815.858 L 20.627 815.858 C 20.59 812.77 20.57 812.487 20.58 809.847 C 20.589 807.244 20.58 807.15 20.627 804.382 Z"
                  style="fill: rgb(175, 185, 213);" />
                <path
                  d="M 719.694 815.858 L 1411.63 815.858 L 1411.63 804.382 L 719.694 804.382 C 719.657 807.47 719.637 807.753 719.647 810.393 C 719.656 812.996 719.647 813.09 719.694 815.858 Z"
                  style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 2131.274414, 1620.23999)" />
                <path
                  d="M 715.512 0.084 C 718.194 0.046 720.069 -0.2 722.861 2.296 C 725.345 4.959 725.318 6.941 725.607 14.37 L 747.477 1564.276 L 715.372 1564.276 L 715.512 0.084 Z"
                  style="fill: rgb(199, 206, 229);" />
                <path
                  d="M 688.858 1563.166 C 691.54 1563.204 693.415 1563.45 696.207 1560.954 C 698.691 1558.291 698.664 1556.309 698.953 1548.88 L 721.945 -1.026 L 689.018 -1.026 L 688.858 1563.166 Z"
                  style="fill: rgb(175, 185, 213);" transform="matrix(-1, 0, 0, -1, 1405.588989, 1563.112183)" />
                <rect x="595.819" y="1559.695" width="241.266" height="35.402" style="fill: rgb(175, 185, 213);"
                  rx="9.48" ry="9.48" />
                <rect x="690.691" y="1559.695" width="146.394" height="35.105" style="fill: rgb(199, 206, 229);"
                  rx="9.48" ry="9.48" />
                <g transform="matrix(1, 0, 0, 1.026298, 1265.407593, -70.336105)">
                  <path
                    d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
                    style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
                  <path
                    d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
                    style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
                  <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
                    style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
                    transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
                  <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);"
                    x1="160.745" y1="353.476" x2="89.88" y2="353.476" />
                  <line
                    style="stroke-width: 16px; stroke-linecap: round; fill: rgb(150, 156, 182); stroke: rgb(155, 165, 192);"
                    x1="82.52" y1="353.476" x2="10.503" y2="353.476" />
                </g>
                <path
                  d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 162.926 352.376 C 159.8 358.193 155.725 366.511 151.726 376.689 C 149.501 381.696 146.783 388.032 142.447 391.688 C 137.671 395.715 128.343 396.674 118.435 396.674 Z"
                  style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(199, 206, 229);" />
                <path
                  d="M 47.951 396.674 C 38.043 396.674 28.715 395.715 23.939 391.688 C 19.603 388.032 16.885 381.696 14.66 376.689 C 10.661 366.511 6.586 358.193 3.46 352.376 L 102.753 352.376 C 99.627 358.193 95.552 366.511 91.553 376.689 C 89.328 381.696 86.61 388.032 82.274 391.688 C 77.498 395.715 68.17 396.674 58.262 396.674 L 47.951 396.674 Z"
                  style="stroke-linejoin: round; stroke-linecap: round; stroke-width: 0px; stroke: rgb(175, 185, 213); fill: rgb(175, 185, 213);" />
                <path d="M 280.545 937.062 L 355.453 1204.746 L 205.637 1204.746 L 280.545 937.062 Z"
                  style="fill: rgba(216, 216, 216, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 16px; stroke: rgb(150, 156, 182);"
                  transform="matrix(1, -0.000013, 0.000013, 1, -195.936844, -851.2453)" />
                <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(175, 185, 213);" x1="160.745"
                  y1="353.476" x2="72.895" y2="353.476" />
                <line style="stroke-width: 16px; stroke-linecap: round; stroke: rgb(155, 165, 192);" x1="80.749"
                  y1="353.792" x2="13.129" y2="353.792" />
                <rect x="77.523" y="62.42" width="1301.521" height="24.403" style="fill: rgb(115, 116, 139);"
                  rx="12.201" ry="12.201"
                  transform="matrix(0.998944, -0.04595, 0.04595, 0.998944, -14.161609, 16.940481)" />
                <circle style="fill: rgb(150, 156, 182);" cx="716.793" cy="57.932" r="34.236" />
                <circle style="fill: rgb(175, 185, 213);" cx="716.793" cy="57.932" r="14.341" />
                <circle style="fill: rgb(175, 185, 213);" cx="84.487" cy="86.683" r="7.085" />
                <circle style="fill: rgb(175, 185, 213);" cx="1349.311" cy="27.363" r="7.085" />
                @if (getLabelLength(getLanguageItem( 'manageability' ))<18) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660" y="410">{{getLanguageItem(
                    'manageability' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageability' ))>17) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="390">{{getFirstHalfOfLabel(getLanguageItem( 'manageability' ))}}</text>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="430">{{getRestOfLabel(getLanguageItem( 'manageability' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))<25) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="510">{{getLanguageItem(
                    'manageabilityrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow1' ))>24) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="490">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow1' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="530">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))<30) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="590">{{getLanguageItem(
                    'manageabilityrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow2' ))>29) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="570">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow2' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="610">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))<33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="670">{{getLanguageItem(
                    'manageabilityrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow3' ))>32) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="650">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow3' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="690">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))<34) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="750">{{getLanguageItem(
                    'manageabilityrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'manageabilityrow4' ))>33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="730">{{getFirstHalfOfLabel(getLanguageItem( 'manageabilityrow4' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="770">{{getRestOfLabel(getLanguageItem(
                    'manageabilityrow4' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulness' ))<18) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660" y="900">{{getLanguageItem(
                    'meaningfulness' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulness' ))>17) {
                  <g>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="880">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
                    <text style="text-anchor:end;" class="svgheaderfont" x="660"
                    y="920">{{getRestOfLabel(getLanguageItem( 'meaningfulness' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))<34) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1010">{{getLanguageItem(
                    'meaningfulnessrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow1' ))>33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="990">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1030">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))<33) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1090">{{getLanguageItem(
                    'meaningfulnessrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow2' ))>32) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1110">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))<30) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1170">{{getLanguageItem(
                    'meaningfulnessrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow3' ))>29) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1190">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))<25) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660" y="1250">{{getLanguageItem(
                    'meaningfulnessrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'meaningfulnessrow4' ))>24) {
                  <g>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
                    <text style="text-anchor:end;" class="svgfont" x="660"
                    y="1270">{{getRestOfLabel(getLanguageItem( 'meaningfulnessrow4' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recovery' ))<18) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770" y="900">{{getLanguageItem(
                    'recovery' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recovery' ))>17) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="880">{{getFirstHalfOfLabel(getLanguageItem( 'recovery' ))}}</text>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="920">{{getRestOfLabel(getLanguageItem( 'recovery' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))<34) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1010">{{getLanguageItem(
                    'recoveryrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow1' ))>33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="990">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1030">{{getRestOfLabel(getLanguageItem( 'recoveryrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))<33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1090">{{getLanguageItem(
                    'recoveryrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow2' ))>32) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1070">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1100">{{getRestOfLabel(getLanguageItem( 'recoveryrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))<30) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1170">{{getLanguageItem(
                    'recoveryrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow3' ))>29) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1150">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1190">{{getRestOfLabel(getLanguageItem( 'recoveryrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))<25) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="1250">{{getLanguageItem(
                    'recoveryrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'recoveryrow4' ))>24) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1230">{{getFirstHalfOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="1270">{{getRestOfLabel(getLanguageItem( 'recoveryrow4' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibility' ))<18) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770" y="410">{{getLanguageItem(
                    'comprehensibility' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibility' ))>17) {
                  <g>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="390">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
                    <text style="text-anchor:start;" class="svgheaderfont" x="770"
                    y="430">{{getRestOfLabel(getLanguageItem( 'comprehensibility' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))<25) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="510">{{getLanguageItem(
                    'comprehensibilityrow1' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow1' ))>24) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="490">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="530">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow1' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))<30) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="590">{{getLanguageItem(
                    'comprehensibilityrow2' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow2' ))>29) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="570">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="610">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow2' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))<33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="670">{{getLanguageItem(
                    'comprehensibilityrow3' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow3' ))>32) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="650">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="690">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow3' ))}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))<34) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770" y="750">{{getLanguageItem(
                    'comprehensibilityrow4' )}}</text>
                  </g>
                }
                @if (getLabelLength(getLanguageItem( 'comprehensibilityrow4' ))>33) {
                  <g>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="730">{{getFirstHalfOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
                    <text style="text-anchor:start;" class="svgfont" x="770"
                    y="770">{{getRestOfLabel(getLanguageItem( 'comprehensibilityrow4' ))}}</text>
                  </g>
                }
                @for (p of participantsFourth; track p) {
                  <use
                    attr.transform="translate({{p.handlingX}}, {{p.handlingY}})"
                    attr.xlink:href="{{getFaceColor(p.handlingValue)}}" />
                }
                @for (p of participantsFourth; track p) {
                  <use
                    attr.transform="translate({{p.meaningfulnessX}}, {{p.meaningfulnessY}})"
                    attr.xlink:href="{{getFaceColor(p.meaningfulnessValue)}}" />
                }
                @for (p of participantsFourth; track p) {
                  <use
                    attr.transform="translate({{p.understandableX}}, {{p.understandableY}})"
                    attr.xlink:href="{{getFaceColor(p.understandableValue)}}" />
                }
                @for (p of participantsFourth; track p) {
                  <use
                    attr.transform="translate({{p.recoverX}}, {{p.recoverY}})"
                    attr.xlink:href="{{getFaceColor(p.recoverValue)}}" />
                }
              </g>
              <g id="excellent" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#151843;stroke:#fff;stroke-width:2px;" />
                <path
                  d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
                  style="fill:#151843;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
              <g id="good" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#9cb2a2;stroke:#fff;stroke-width:2px;" />
                <path
                  d="M17.241,43.302c0,4.556 6.599,8.255 14.726,8.255c8.128,-0 14.726,-3.699 14.726,-8.255c0,4.556 -6.598,8.255 -14.726,8.255c-8.127,-0 -14.726,-3.699 -14.726,-8.255Z"
                  style="fill:#151843;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
              <g id="unsatisfying" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#dbbf8d;stroke:#fff;stroke-width:2px;" />
                <path d="M19.196,48.757l29.076,-9.884" style="fill:none;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
              <g id="bad" transform="scale(1.5625) translate(-100, -100)">
                <circle cx="32" cy="32" r="32" style="fill:#de0621;stroke:#fff;stroke-width:2px;" />
                <path
                  d="M45.219,47.959c0,-3.7 -5.903,-6.704 -13.175,-6.704c-7.272,-0 -13.176,3.004 -13.176,6.704c-0,-3.7 5.904,-6.704 13.176,-6.704c7.272,-0 13.175,3.004 13.175,6.704Z"
                  style="fill:#151843;stroke:#fff;stroke-width:4px;" />
                <circle cx="20" cy="23" r="6" style="fill:#fff;" />
                <circle cx="44" cy="23" r="6" style="fill:#fff;" />
              </g>
            </svg>
          </div>
        }
      </div>
    </div>
  }
</div>

@if (errMessage != '') {
  <div class="wbt-spacing-bottom-16 wbt-spacing-right-16"
    style="position: fixed; bottom: 0px; right: 0;">
    <tds-toast
      variant="{{toastVariant}}"
      header="{{toastHeader}}"
      subheader="{{errMessage}}" >
    </tds-toast>
  </div>
}
